// extracted by mini-css-extract-plugin
var _1 = "_confirmStockoutTransactionsModal-module__button-container";
var _2 = "_confirmStockoutTransactionsModal-module__cancel-button";
var _3 = "_confirmStockoutTransactionsModal-module__confirm-approve";
var _4 = "_confirmStockoutTransactionsModal-module__confirm-reject";
var _5 = "_confirmStockoutTransactionsModal-module__section";
export { _1 as "button-container", _2 as "cancel-button", _3 as "confirm-approve", _4 as "confirm-reject", _5 as "section" }
